/* Cart A/B test: tagging, events and the actions of the "gift-ready" cart (B).
   The arm is decided inline by snippets/cart-ab.liquid (window.CharmlryCartAB). */
(function () {
  var AB = window.CharmlryCartAB;
  if (!AB || window.CharmlryCartABInit) return;
  window.CharmlryCartABInit = true;

  var noTrack = AB.source === 'off' || AB.source === 'override' || !!(window.Shopify && window.Shopify.designMode) || !!navigator.webdriver;
  var queue = [];
  function flush() {
    if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return false;
    while (queue.length) { var ev = queue.shift(); try { Shopify.analytics.publish(ev[0], ev[1]); } catch (e) { /* ignore */ } }
    return true;
  }
  var tries = 0;
  var timer = setInterval(function () { if (flush() || ++tries > 40) clearInterval(timer); }, 250);
  function publish(name, data) {
    var payload = Object.assign({ ab_cart: AB.arm, ab_cart_source: AB.source }, data || {});
    try { document.dispatchEvent(new CustomEvent('charmlry:cartab', { detail: { name: name, data: payload } })); } catch (e) { /* ignore */ }
    if (noTrack) return;
    queue.push([name, payload]);
    flush();
  }
  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error(e.description || e.message || 'Cart error'); });
      return r.json();
    });
  }
  function cart() { return json('/cart.js'); }

  /* The order remembers the cart it saw. Only when the test is on (or forced). */
  function tag() {
    if (AB.source === 'off') return;
    if (AB.attr === AB.arm && AB.attrSource === AB.source) return;
    json('/cart/update.js', { attributes: { ab_cart: AB.arm, ab_cart_source: AB.source } }).catch(function () { /* retried next view */ });
  }

  /* Re-render the cart sections in place (same areas Dawn's cart.js swaps). */
  function refresh() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var ids = [items && items.dataset.id, footer && footer.dataset.id, 'cart-icon-bubble'].filter(Boolean);
    return fetch('/cart?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (map) {
        var swap = function (host, id, sel) {
          if (!host || !map[id]) return;
          var doc = new DOMParser().parseFromString(map[id], 'text/html');
          var src = doc.querySelector(sel), dst = host.querySelector(sel);
          if (src && dst) dst.innerHTML = src.innerHTML;
        };
        swap(items, items && items.dataset.id, '.js-contents');
        swap(footer, footer && footer.dataset.id, '.js-contents');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && map['cart-icon-bubble']) {
          var d = new DOMParser().parseFromString(map['cart-icon-bubble'], 'text/html');
          var b = d.querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function () { location.reload(); });
  }

  function isGift(i) { return i.handle === 'gift-box-charmlry'; }

  var actions = {
    'box-plus': function () { return json('/cart/add.js', { items: [{ id: AB.gift.id, quantity: 1 }] }); },
    'box-every': function (el) {
      var n = Math.max(1, +el.getAttribute('data-missing') || 1);
      return json('/cart/add.js', { items: [{ id: AB.gift.id, quantity: n }] });
    },
    'box-minus': function () {
      return cart().then(function (c) {
        var lines = (c.items || []).filter(isGift);
        if (!lines.length) return null;
        // Prefer the plain line (customizer and cart adds merge into it).
        var line = lines.filter(function (l) { return !l.properties || !Object.keys(l.properties).length; })[0] || lines[0];
        return json('/cart/change.js', { id: line.key, quantity: line.quantity - 1 });
      });
    },
    'card-on': function (el) {
      var key = el.getAttribute('data-key');
      return cart().then(function (c) {
        var item = (c.items || []).filter(function (i) { return i.key === key; })[0];
        if (!item) return null;
        var props = Object.assign({}, item.properties || {});
        if (!props._created_at) props._created_at = String(Date.now());
        props['scratch card'] = 'yes';
        var name = props.name || props.Name || props['Name 1'] || '';
        return json('/cart/change.js', { id: key, quantity: item.quantity, properties: props }).then(function () {
          return json('/cart/add.js', { items: [{ id: AB.card.id, quantity: item.quantity, properties: { name: name, _card: item.handle, _created_at: props._created_at } }] });
        });
      });
    },
    'card-off': function (el) {
      var key = el.getAttribute('data-key');
      return cart().then(function (c) {
        var item = (c.items || []).filter(function (i) { return i.key === key; })[0];
        if (!item) return null;
        var props = Object.assign({}, item.properties || {});
        var ca = props._created_at;
        props['scratch card'] = 'no';
        var updates = {};
        (c.items || []).forEach(function (i) {
          var p = i.properties || {};
          if (p._card === item.handle && p._created_at === ca) updates[i.key] = 0;
        });
        return json('/cart/change.js', { id: key, quantity: item.quantity, properties: props }).then(function () {
          return Object.keys(updates).length ? json('/cart/update.js', { updates: updates }) : null;
        });
      });
    },
    'warranty-add': function () { return json('/cart/add.js', { items: [{ id: AB.warranty.id, quantity: 1 }] }); },
    'warranty-remove': function () {
      return cart().then(function (c) {
        var updates = {};
        (c.items || []).forEach(function (i) { if (i.handle === 'lifetime-warranty') updates[i.key] = 0; });
        return Object.keys(updates).length ? json('/cart/update.js', { updates: updates }) : null;
      });
    },
  };

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cab-action]');
    if (!el) return;
    var name = el.getAttribute('data-cab-action');
    var fn = actions[name];
    if (!fn || el.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    el.setAttribute('aria-busy', 'true');
    document.documentElement.classList.add('cab-busy');
    publish('ab_cart_action', { action: name });
    Promise.resolve()
      .then(function () { return fn(el); })
      .then(refresh)
      .catch(function () { location.reload(); })
      .then(function () { document.documentElement.classList.remove('cab-busy'); el.removeAttribute('aria-busy'); });
  });

  /* Checkout: the form's submit, wherever it starts (sticky button, keyboard). */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'cart') return;
    publish('ab_cart_checkout', {});
  }, true);

  function boot() {
    tag();
    cart().then(function (c) {
      var pieces = 0, boxes = 0;
      (c.items || []).forEach(function (i) {
        var p = i.properties || {};
        if (isGift(i)) boxes += i.quantity;
        else if (!p._parent && !p._card && (p.name || p.Name || p['Name 1'] || p.Letters || p['Zodiac signs'])) pieces += i.quantity;
      });
      publish('ab_cart_view', { pieces: pieces, boxes: boxes, subtotal: (c.items_subtotal_price || 0) / 100, currency: c.currency });
    }).catch(function () { publish('ab_cart_view', {}); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
